import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux'; // Add this
import { getAvailableTabs } from '../custom';

function TabNavigation({ activeTab, activeTabList, onTabChange, onTabListChange, handleCloseAllClick }) {

    const mainTabs = ['Active', 'square_off'];

    const availableTabs = useMemo(() => {
        const tabs = getAvailableTabs();
        return ["ALL", ...tabs.filter(tab => tab !== "ALL")];
    }, []);

    const { orders, allmarketData, fetchData, error, exchangeTokens } = useSelector((state) => state.portfolio);

    return (
        <Box sx={{ width: '100%', marginTop: '0px' }}>
            {/* Main Tabs */}
            <div className="flex items-center justify-center mb-0">
                <div className="flex bg-gray-200 w-[250px] h-[35px]">
                    {mainTabs.map((tab) => (
                        <button
                            key={tab}
                            type="button"
                            onClick={() => onTabChange(tab)}
                            className={`${activeTab === tab
                                ? 'bg-[#2f67f0] text-white'
                                : 'bg-gray-200 text-black'
                                } w-1/2 h-full text-sm font-lato transition-colors`}
                        >
                            {tab.replace(/_/g, ' ').toUpperCase()}
                        </button>
                    ))}
                </div>
            </div>
            {activeTab !== 'square_off' && Object.keys(exchangeTokens).length !== 0 ? (
                <div className="flex items-center justify-end mb-4 mt-3">
                    <button type="button"
                        onClick={handleCloseAllClick}
                        className="text-white bg-gradient-to-r from-blue-300 via-blue-400 to-blue-500 hover:bg-gradient-to-br font-medium rounded-lg text-sm px-4 py-1 text-center me-2">Close All</button>
                </div>
            ) : null}
            {/* Sub Tabs */}
            <div className="flex space-x-2 mt-[15px]">
                {availableTabs.map((tab) => (
                    <button
                        key={tab}
                        className={`py-0 px-[11px] text-sm font-lato font-semibold ${activeTabList === tab
                            ? 'border-b-[2px] border-blue-500 text-blue-500'
                            : 'hover:text-blue-500'
                            }`}
                        onClick={() => onTabListChange(tab)}
                    >
                        {tab}
                    </button>
                ))}
            </div>
        </Box>
    );
}

export default TabNavigation;